import {isSSG} from "src/server/utils/isSSG";
import {getAxiosInstance} from "src/server/utils/getAxiosInstance";
import * as ProductsApi from "src/core/api/products";
import once from "lodash/once";
import {isClient} from "src/server/utils/isClient";
import {store} from "src/core/api/cache";
import {
  clearStoreCache,
  filterCacheKeys,
  safePreload,
  withCache,
} from "src/server/preloader/utils";
import {shopExists} from "src/server/utils/shopExists";

const fetchProductData = safePreload(async (shop, host, productId) => {
  if (!isSSG() && !shopExists(shop, host)) return null;

  await clearStoreCache(shop, host);
  const axiosInstance = getAxiosInstance(shop, host);
  try {
    console.log("REQUESTING PRODUCT " + shop);
    const d = new Date().getTime();
    const productData = await ProductsApi.detail(productId, axiosInstance);
    console.log("REQUESTING PRODUCT TIME: ", new Date().getTime() - d);
    return {
      storeObject: filterCacheKeys(shop, host, store.serialize()),
      productData,
    };
  } catch (e) {
    return {
      storeObject: {},
    };
  }
});

export const getProduct = withCache(fetchProductData, ".product");

export const saveProduct = once(({storeObject}) => {
  if (isSSG() && !isClient) return;

  storeObject && store.setStore(storeObject);
});
